import { Popover, type PopoverProps } from "antd";
import { memo, type ReactNode } from "react";

export interface CustomPopoverProps extends PopoverProps {
  content?: ReactNode;
  visible?: boolean;
  onOpenChange?: (open: boolean) => void;
  children?: ReactNode;
}

function CustomPopover({
  content,
  visible,
  onOpenChange,
  children,
  ...rest
}: CustomPopoverProps) {
  return (
    <Popover
      content={content}
      trigger="click"
      open={visible}
      onOpenChange={onOpenChange}
      {...rest}
    >
      <div>{children}</div>
    </Popover>
  );
}

export default memo(CustomPopover);
